/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = {
  muc1: [
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
    },
  ],
  muc2: [
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
    },
  ],
};

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType].map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (rowType) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
    };
    setData((prev) => ({ ...prev, [rowType]: [...prev[rowType], newRow] }));
  };

  const handleDelete = (rowType, id) => {
    setData((prev) => ({ ...prev, [rowType]: prev[rowType].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại khoáng sản
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số lượng đất đá bốc xúc thải (m3)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mức phí của đất đá bốc xúc thải
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Số lượng quặng khoáng sản nguyên khai khai thác
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mức phí theo từng loại khoáng sản
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Hệ số tính phí theo phương pháp khai thác
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số phí phải nộp trong kỳ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số lượng
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (8)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (9) = [(3)x(4)x(8)] + [(6)x(7)x(8)]
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900 }}
              >
                I
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", whiteSpace: "nowrap", fontWeight: 900 }}>
                Khoáng sản do cơ sở tự khai thác
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
            {data.muc1.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xoá dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({
                        rowType: "muc1",
                        id: item.id,
                        name: "value2",
                        value: e.target.value,
                      })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    value={item.value3}
                    name="value3"
                    onChange={handleChange}
                    rowType="muc1"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    rowType="muc1"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({
                        rowType: "muc1",
                        id: item.id,
                        name: "value5",
                        value: e.target.value,
                      })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                    rowType="muc1"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                    rowType="muc1"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                    rowType="muc1"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                  0
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900 }}
              >
                II
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", fontWeight: 900 }}>
                Khoáng sản do tổ chức thu mua gom nộp thay người khai thác nhỏ lẻ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
            {data.muc2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                      Xoá dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({
                        rowType: "muc2",
                        id: item.id,
                        name: "value2",
                        value: e.target.value,
                      })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    value={item.value3}
                    name="value3"
                    onChange={handleChange}
                    rowType="muc2"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    rowType="muc2"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({
                        rowType: "muc1",
                        id: item.id,
                        name: "value5",
                        value: e.target.value,
                      })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                    rowType="muc2"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                    rowType="muc2"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                    rowType="muc2"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                  0
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                rowSpan={1}
                colSpan={8}
                style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}
              >
                Tổng cộng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name, rowType });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
